import { TodoListElement } from '@typedream/core';
import { createAutoformatPlugin as createPlateAutoformatPlugin } from '@udecode/plate-autoformat';
import { getParentNode, isBlock, isElement, isType, setNodes, TEditor } from '@udecode/plate-core';
import { toggleList, unwrapList } from '../../nodes/list/transforms';
import {
  ELEMENT_CODE_BLOCK,
  ELEMENT_CODE_LINE,
  ELEMENT_H1,
  ELEMENT_H2,
  ELEMENT_H3,
  KEY_AUTOFORMAT,
  MARK_BOLD,
  MARK_CODE,
  MARK_ITALIC,
  MARK_STRIKETHROUGH,
  MARK_UNDERLINE,
} from '../../pluginKeys';
import { DreamEditor } from '../../types';

const query = (editor: TEditor) => {
  if (!editor.selection) return false;

  const [parentNode] = getParentNode(editor, editor.selection) || [];

  if (
    !parentNode ||
    !isElement(parentNode) ||
    isType(editor as unknown as DreamEditor, parentNode, ELEMENT_CODE_BLOCK) ||
    isType(editor as unknown as DreamEditor, parentNode, ELEMENT_CODE_LINE)
  ) {
    return false;
  }

  return true;
};

const preFormat = (editor: TEditor) => {
  unwrapList(editor as unknown as DreamEditor);
};

export const createAutoFormatPlugin = () =>
  createPlateAutoformatPlugin({
    key: KEY_AUTOFORMAT,
    options: {
      rules: [
        {
          mode: 'block',
          type: ELEMENT_H1,
          match: '# ',
          query,
          preFormat,
        },
        {
          mode: 'block',
          type: ELEMENT_H2,
          match: '## ',
          query,
          preFormat,
        },
        {
          mode: 'block',
          type: ELEMENT_H3,
          match: '### ',
          query,
          preFormat,
        },
        {
          mode: 'mark',
          type: MARK_BOLD,
          match: '**',
          query,
        },
        {
          mode: 'mark',
          type: MARK_UNDERLINE,
          match: '__',
          query,
        },
        {
          mode: 'mark',
          type: MARK_ITALIC,
          match: '*',
          query,
        },
        {
          mode: 'mark',
          type: MARK_ITALIC,
          match: '_',
          query,
        },
        {
          mode: 'mark',
          type: MARK_CODE,
          match: '`',
          query,
        },
        {
          mode: 'mark',
          type: MARK_STRIKETHROUGH,
          match: '~~',
          query,
        },
      ],
    },
  });
